import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnDestroy, NgZone } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CheckboxSubcategoria } from '../etc/categoria-checkbox.interface';
import { MarianomGeneral } from '../marianom-general.service';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { Ciudad } from 'projects/mariano-max/src/app/core/ecommerce-generico/interfaces/ciudades-envío.interface';
import { DatosEnvio } from 'projects/mariano-max/src/app/core/ecommerce-generico/interfaces/envios.interface';
import { ZonaEntrega } from 'projects/mariano-max/src/app/core/ecommerce-generico/interfaces/zona-entrega.interface';
import * as L from 'leaflet';

const DEFAULT_LAT = -34.6037;
const DEFAULT_LNG = -58.3816;
const DEFAULT_ZOOM = 13;

@Component({
  selector: 'app-envios-form',
  templateUrl: './envios-form.component.html',
  styleUrls: ['./envios-form.component.scss']
})

export class EnviosFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() envioSeleccionado: EventEmitter<DatosEnvio> = new EventEmitter();

  formEnvio: UntypedFormGroup;
  ciudades: any[];
  ciudadesArray: any[] = [];
  costoEnvio: number;
  error: boolean;
  ciudadElegida: string;
  mostrarCosto: boolean = false;
  modo: number;

  mapVisible: boolean = false;
  buscandoDireccion: boolean = false;
  pinLatitud: number | null = null;
  pinLongitud: number | null = null;
  fueraDeZona: boolean = false;
  cargandoZona: boolean = false;

  private map: L.Map | null = null;
  private marker: L.Marker | null = null;
  private zonaPoligono: L.Polygon | null = null;
  private zonaCoords: [number, number][] = [];
  private mapInitialized: boolean = false;
  private ciudadSeleccionadaId: number | null = null;

  constructor(
    private serv: MarianomGeneral,
    private genServ: EcommerceGenericoService,
    private formBuilder: UntypedFormBuilder,
    private ngZone: NgZone
  ) {
    this.error = false;
    this.modo = this.serv.returnRetiroEnvio();
    this.ciudades = [{ nombre: 'Cargando ciudades...', categorias: [] }];
  }

  ngOnInit(): void {
    this.genServ.getCiudades().subscribe({
      next: data => {
        if (data['registros'].length != 0) {
          data['registros'].forEach(ciudad => {
            if (this.modo === 2 && ciudad.costoexpress === 0) return;
            if (this.modo == 2) ciudad.costo = ciudad.costo + ciudad.costoexpress;

            let nuevaCiudad: Ciudad = {
              ciudad: ciudad.ciudad,
              nombre: ciudad.nombre.trim(),
              cp: ciudad.cp,
              costo: ciudad.costo >= 0 ? ciudad.costo : 0
            };
            this.ciudadesArray.push(nuevaCiudad);

            if (ciudad.ciudad === this.genServ.getUser().ciudad) {
              this.ciudadElegida = nuevaCiudad.nombre;
            }
          });
          this.prepararCiudades();
          this.ciudades[0].categorias.forEach(ciudadSelectOption => {
            if (ciudadSelectOption.nombre === this.ciudadElegida) {
              this.ciudadElegida = ciudadSelectOption.nombre;
              this.serv.setSelectorName(this.ciudadElegida);
              this.ciudadSeleccionada(ciudadSelectOption);
            }
          });
        } else {
          this.error = true;
        }
      },
      error: () => { this.error = true; }
    });

    this.formEnvio = this.formBuilder.group({
      barrio: ['', [Validators.required]],
      calle: ['', [Validators.required]],
      numero: ['', [Validators.required]],
      ciudad: ['', [Validators.required]],
      nombreCiudad: ['', [Validators.required]],
      costo: ['', [Validators.required]],
      cp: ['', [Validators.required]],
    });
  }

  ngAfterViewInit(): void {
    this.fixLeafletIcons();
  }

  ngOnDestroy(): void {
    this.destroyMap();
  }

  get ciudad() { return this.formEnvio.value.ciudad; }
  get codigoPostal() { return this.formEnvio.value.cp; }
  get costo() { return this.formEnvio.value.costo; }

  prepararCiudades() {
    let i = 0;
    this.ciudades = [{ nombre: 'Elegir ciudad', categorias: [] }];
    this.ciudadesArray.forEach(k => {
      let ciudadDisponible: CheckboxSubcategoria = { nombre: '', activada: false, id: '' };
      ciudadDisponible.nombre = k.nombre;
      ciudadDisponible.id = (i).toString();
      this.ciudades[0].categorias.push(ciudadDisponible);
      i++;
    });
  }

  ciudadSeleccionada(filtro: CheckboxSubcategoria) {
    this.formEnvio.reset();
    this.ciudades[0].categorias.forEach(k => { k.activada = false; });
    this.ciudades[0].nombre = filtro.nombre;
    this.formEnvio.patchValue({ nombreCiudad: filtro.nombre });
    filtro.activada = true;

    this.ciudadesArray.forEach(ciudadEnvio => {
      if (this.ciudades[0].nombre == ciudadEnvio.nombre) {
        this.formEnvio.patchValue({ ciudad: ciudadEnvio.ciudad });
        this.formEnvio.patchValue({ cp: ciudadEnvio.cp });
        this.formEnvio.patchValue({ costo: ciudadEnvio.costo });
        this.mostrarCosto = true;
        this.ciudadSeleccionadaId = ciudadEnvio.ciudad;
      }
    });

    this.ciudadElegida = filtro.nombre;
    this.fueraDeZona = false;
    this.pinLatitud = null;
    this.pinLongitud = null;
    this.datosEnvio();
    this.mostrarMapa(filtro.nombre);
  }

  mostrarMapa(nombreCiudad: string) {
    this.mapVisible = true;
    setTimeout(() => {
      if (!this.mapInitialized) {
        this.initMap();
      } else {
        this.limpiarPinYZona();
      }
      this.geocodificarCiudad(nombreCiudad);
      this.cargarZonaEntrega();
    }, 100);
  }

  private initMap() {
    const mapContainer = document.getElementById('mapa-entrega');
    if (!mapContainer) return;

    this.map = L.map('mapa-entrega', {
      center: [DEFAULT_LAT, DEFAULT_LNG],
      zoom: DEFAULT_ZOOM
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19
    }).addTo(this.map);

    this.map.on('click', (e: L.LeafletMouseEvent) => {
      this.ngZone.run(() => {
        this.colocarPin(e.latlng.lat, e.latlng.lng, true);
      });
    });

    this.mapInitialized = true;
  }

  private cargarZonaEntrega() {
    if (!this.ciudadSeleccionadaId) return;

    this.cargandoZona = true;
    this.genServ.getZonaEntrega(this.ciudadSeleccionadaId).subscribe({
      next: (data: any) => {
        this.ngZone.run(() => {
          this.cargandoZona = false;
          if (data['registros'] && data['registros'].length > 0) {
            const zona: ZonaEntrega = data['registros'][0];
            this.zonaCoords = zona.coordenadas;
            this.dibujarPoligono(zona.coordenadas);
          } else {
            this.zonaCoords = [];
          }
        });
      },
      error: () => {
        this.ngZone.run(() => {
          this.cargandoZona = false;
          this.zonaCoords = [];
        });
      }
    });
  }

  private dibujarPoligono(coordenadas: [number, number][]) {
    if (!this.map) return;

    if (this.zonaPoligono) {
      this.zonaPoligono.remove();
      this.zonaPoligono = null;
    }

    if (coordenadas.length < 3) return;

    this.zonaPoligono = L.polygon(coordenadas, {
      color: '#A81D03',
      fillColor: '#A81D03',
      fillOpacity: 0.12,
      weight: 2,
      dashArray: '6, 4'
    }).addTo(this.map);

    this.map.fitBounds(this.zonaPoligono.getBounds(), { padding: [20, 20] });
  }

  private limpiarPinYZona() {
    if (this.marker) {
      this.marker.remove();
      this.marker = null;
    }
    if (this.zonaPoligono) {
      this.zonaPoligono.remove();
      this.zonaPoligono = null;
    }
    this.zonaCoords = [];
    this.pinLatitud = null;
    this.pinLongitud = null;
    this.fueraDeZona = false;
  }

  private geocodificarCiudad(nombreCiudad: string) {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(nombreCiudad + ', Argentina')}&limit=1`;
    fetch(url, { headers: { 'Accept-Language': 'es' } })
      .then(res => res.json())
      .then(data => {
        if (data && data.length > 0) {
          const lat = parseFloat(data[0].lat);
          const lng = parseFloat(data[0].lon);
          this.ngZone.run(() => {
            if (this.map && !this.zonaPoligono) {
              this.map.setView([lat, lng], DEFAULT_ZOOM);
            }
          });
        }
      })
      .catch(() => {});
  }

  buscarDireccion() {
    const calle = this.formEnvio.value.calle;
    const numero = this.formEnvio.value.numero;
    const ciudad = this.ciudadElegida;
    if (!calle || !ciudad) return;

    const direccion = `${calle} ${numero || ''}, ${ciudad}, Argentina`;
    this.buscandoDireccion = true;

    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(direccion)}&limit=1`;
    fetch(url, { headers: { 'Accept-Language': 'es' } })
      .then(res => res.json())
      .then(data => {
        this.ngZone.run(() => {
          this.buscandoDireccion = false;
          if (data && data.length > 0) {
            const lat = parseFloat(data[0].lat);
            const lng = parseFloat(data[0].lon);
            this.colocarPin(lat, lng, false);
            if (this.map) this.map.setView([lat, lng], 16);
          }
        });
      })
      .catch(() => { this.ngZone.run(() => { this.buscandoDireccion = false; }); });
  }

  private colocarPin(lat: number, lng: number, actualizarFormulario: boolean = false) {
    if (this.zonaCoords.length >= 3 && !this.puntoEnPoligono(lat, lng, this.zonaCoords)) {
      this.fueraDeZona = true;
      if (this.marker) {
        this.marker.remove();
        this.marker = null;
      }
      this.pinLatitud = null;
      this.pinLongitud = null;
      return;
    }

    this.fueraDeZona = false;
    this.pinLatitud = lat;
    this.pinLongitud = lng;

    if (this.marker) {
      this.marker.setLatLng([lat, lng]);
    } else if (this.map) {
      this.marker = L.marker([lat, lng], { draggable: true }).addTo(this.map);
      this.marker.on('dragend', (e: any) => {
        const pos = e.target.getLatLng();
        this.ngZone.run(() => {
          this.pinLatitud = pos.lat;
          this.pinLongitud = pos.lng;
          this.geocodificarInverso(pos.lat, pos.lng);
        });
      });
    }

    if (actualizarFormulario) {
      this.geocodificarInverso(lat, lng);
    } else {
      this.datosEnvio();
    }
  }

  private puntoEnPoligono(lat: number, lng: number, coordenadas: [number, number][]): boolean {
    let inside = false;
    const n = coordenadas.length;
    for (let i = 0, j = n - 1; i < n; j = i++) {
      const [yi, xi] = coordenadas[i];
      const [yj, xj] = coordenadas[j];
      const intersect = ((yi > lat) !== (yj > lat)) &&
        (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  private geocodificarInverso(lat: number, lng: number) {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=es`;
    fetch(url)
      .then(res => res.json())
      .then(data => {
        this.ngZone.run(() => {
          if (data && data.address) {
            const addr = data.address;
            const calle = addr.road || addr.pedestrian || addr.footway || '';
            const numero = addr.house_number || '';
            const barrio = addr.suburb || addr.neighbourhood || addr.quarter || addr.village || '';
            if (calle) this.formEnvio.patchValue({ calle });
            if (numero) this.formEnvio.patchValue({ numero });
            if (barrio) this.formEnvio.patchValue({ barrio });
          }
          this.datosEnvio();
        });
      })
      .catch(() => { this.ngZone.run(() => this.datosEnvio()); });
  }

  private fixLeafletIcons() {
    const iconDefault = L.icon({
      iconUrl: 'assets/leaflet/marker-icon.png',
      iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
      shadowUrl: 'assets/leaflet/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    L.Marker.prototype.options.icon = iconDefault;
  }

  private destroyMap() {
    if (this.map) {
      this.map.remove();
      this.map = null;
      this.marker = null;
      this.zonaPoligono = null;
      this.mapInitialized = false;
    }
  }

  datosEnvio() {
    if (!this.formEnvio.valid) return;
    const datos: DatosEnvio = {
      ...this.formEnvio.value,
      latitud: this.pinLatitud ?? undefined,
      longitud: this.pinLongitud ?? undefined
    };
    this.envioSeleccionado.emit(datos);
  }
}
